import { useContext } from 'react';
import { PlatformContext, type PlatformContextValue } from '@/contexts/platformContextValue';

export const usePlatform = (): PlatformContextValue => {
    const context = useContext(PlatformContext);
    if (!context) {
        throw new Error('usePlatform must be used within PlatformProvider');
    }
    return context;
};
